export const reduxKey = '@@ADS';
export const actionKey = '@@ADS';
